import loadGoogleMapsApi from 'load-google-maps-api';
import { style } from './mapStyle';
import { mapLabels, staticMapLabels } from './data';
import anime from 'animejs';

let map;
let gmap;
let amenityMarkers = [];
let selectedIndex = 0;
let thumbs = [];
let params;
let canAutoplay = true;
let autoPlayInstance = null;

export function CleanAmenityGallery() {
	// canAutoplay = false;
	if (autoPlayInstance) clearInterval(autoPlayInstance);
	thumbs = [];
	amenityMarkers = [];
	selectedIndex = 0;
}

function Autoplay() {
	if (canAutoplay) {
		NavigateAmenitySlide('next', true);
	}
}

//MAP STUFF GOES HERE -------------------------------------------------------------------

export function InitMap(_params) {
	//ONLY RUN THIS ONCE
	loadGoogleMapsApi({ key: 'AIzaSyA5e6sF73xl-ayJigo_o6EdvrcClb-kOys' }).then((_gmap) => {
		gmap = _gmap;
		params = _params;
		const buildingLocation = new gmap.LatLng(51.507249,  -0.142795);
		map = new gmap.Map(params.map, {
			center: buildingLocation,
			styles: style,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
			zoom: 16
		});

		const buildingMarkerIcon = {
			url: 'images/map-pin-inverted.png',
			scaledSize: new gmap.Size(58, 67),
			anchor: new gmap.Point(29, 0)
		};

		const buildingMarker = new gmap.Marker({
			position: buildingLocation,
			map: map,
			zIndex: 15,
			icon: buildingMarkerIcon
		});

		const buildingShadeBounds = {
			north: 51.50755,
			south: 51.50685,
			east: -0.1422,
			west: -0.14335
		};

		const buildingShade = new gmap.GroundOverlay(
			'http://p3.sirendev.co.uk/temp/building-shade.png',
			buildingShadeBounds
		);
		buildingShade.setMap(map);

		staticMapLabels.map((label) => {
			const staticLabel = new gmap.Marker({
				position: new gmap.LatLng(label.pos.lat, label.pos.lng),
				map: map,
				icon: {
					url: `./images/${label.img}`,
					scaledSize: new gmap.Size(label.size.width, label.size.height),
					anchor: new gmap.Point(label.size.width / 2, label.size.height / 2)
				}
			});
		});

		//LATE CALLERS
		PopulateAmenityPins();
		InitAmenityGallery(params);
		JumpToSlide(0, true);
	});
}

function SelectPin(i) {
	selectedIndex = i;
	PopulateAmenityPins();
}

function PopulateAmenityPins() {
	ClearAmenityPins();

	mapLabels.map((label, i) => {
		const labelPin = new gmap.Marker({
			position: new gmap.LatLng(label.pos.lat, label.pos.lng),
			map: map,
			zIndex: 10,
			icon: {
				url: `images/${i === selectedIndex ? label.imgSelected : label.img}`,
				scaledSize: new gmap.Size(label.size.width, label.size.height),
				anchor: new gmap.Point(label.size.width / 2, label.size.height / 2)
			}
		});

		labelPin.addListener('click', () => {
			JumpToSlide(i);
		});

		amenityMarkers.push(labelPin);
	});
}

function ClearAmenityPins() {
	amenityMarkers.map((m) => m.setMap(null));
}

//GALLERY STUFF GOES HERE -------------------------------------------------------------------
function InitAmenityGallery() {
	mapLabels.map((l, i) => {
		const d = document.createElement('div');
		d.classList.add('thumb');
		d.onclick = () => {
			JumpToSlide(i);
		};
		params.galleryThumbCont.appendChild(d);
		thumbs.push(d);
	});
	canAutoplay = true;
	autoPlayInstance = setInterval(Autoplay, 5000);
}

export function JumpToSlide(i, keepAutoPlay = false) {
	if (keepAutoPlay) {
		canAutoplay = true;
	} else {
		canAutoplay = false;
	}
	SelectPin(i);
	//select thumb
	thumbs.map((t) => t.classList.remove('thumb-active'));
	thumbs[i].classList.add('thumb-active');
	params.galleryTitle.innerHTML = mapLabels[i].label;

	anime({
		targets: params.galleryImage,
		opacity: [ 1, 0 ],
		duration: 400,
		easing: 'easeInOutQuad',
		complete: () => {
			params.galleryImage.style.backgroundImage = `url(images/gallery/${mapLabels[i].galleryImg})`;
			anime({
				targets: params.galleryImage,
				opacity: [ 0, 1 ],
				duration: 400,
				easing: 'easeInOutQuad'
			});
		}
	});
}

export function NavigateAmenitySlide(_dir, keepAutoPlay = null) {
	let dir = 0;
	if (_dir === 'next') {
		dir = +1;
	} else if (_dir === 'prev') {
		dir = -1;
	}

	let newIndex = selectedIndex + dir;

	if (newIndex > mapLabels.length - 1) {
		newIndex = 0;
	} else if (newIndex < 0) {
		newIndex = mapLabels.length - 1;
	}

	JumpToSlide(newIndex, keepAutoPlay);
}

function Autoplay() {
	if (canAutoplay) {
		NavigateAmenitySlide('next', true);
	}
}



// WEBPACK FOOTER //
// ./src/mapGallery.js